module.exports = __webpack_public_path__ + "img/joker_460.077ee186.png";